'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Divider } from '@heroui/react';
import type { Transition, UseInViewOptions } from 'framer-motion';
import Link from 'next/link';
import BackgroundImage from '@/components/svgs/background';
import InView from '@/components/ui/in-view';
import { TypingEffect } from '@/components/ui/typing-effect';
import { useLastVisitedRoute } from '@/hooks/use-last-visited-route';
import { APP_ROUTES } from '@/shared/constants/app-routes';
export default function NotFound() {
  const $ = _c(19);
  const {
    resumeLastVisitedRoute
  } = useLastVisitedRoute();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      duration: 2,
      ease: "easeInOut"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const transition = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      margin: "0px 0px -0px 0px"
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const viewOptions = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <BackgroundImage color="var(--color-clube-green-darker)" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      opacity: 0,
      filter: "blur(4px)"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      hidden: t3,
      visible: {
        opacity: 1,
        filter: "blur(0px)",
        transition: {
          delay: 0.1
        }
      }
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <InView variants={t4} viewOptions={viewOptions} transition={transition} className="flex max-w-4xl flex-col gap-1 text-center text-3xl xsm:text-4xl sm:text-6xl"><div className="flex w-full items-center justify-center gap-4"><TypingEffect className="font-bold text-9xl text-clube-gray-light" text="404 " /></div><TypingEffect className="font-bold text-white" text={"P\xE1gina n\xE3o encontrada"} /></InView>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      opacity: 0,
      filter: "blur(4px)"
    };
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      hidden: t6,
      visible: {
        opacity: 1,
        filter: "blur(0px)",
        transition: {
          delay: 0.1
        }
      }
    };
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <InView variants={t7} viewOptions={viewOptions} transition={transition} className="flex max-w-4xl flex-col gap-1 text-center text-lg"><h1 className="text-white">Verifique o link ou volte para a página inicial para continuar navegando.</h1></InView>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      opacity: 0,
      filter: "blur(4px)"
    };
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      hidden: t9,
      visible: {
        opacity: 1,
        filter: "blur(0px)",
        transition: {
          delay: 0.1
        }
      }
    };
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <InView variants={t10} viewOptions={viewOptions} transition={transition} className="max-w-4xl w-full"><Divider className="w-full bg-clube-gold" /></InView>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      scale: 0,
      filter: "blur(4px)"
    };
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      hidden: t12,
      visible: {
        scale: 1,
        filter: "blur(0px)",
        transition: {
          delay: 0.1
        }
      }
    };
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <InView variants={t13} viewOptions={viewOptions} transition={transition} className="sm:w-auto w-full"><Link href={APP_ROUTES.PRIVATE.HOME} className="sm:w-auto w-full"><Button as="div" radius="full" variant="solid" size="lg" className="text-lg w-full text-white bg-clube-black">Início</Button></Link></InView>;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      scale: 0,
      filter: "blur(4px)"
    };
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      hidden: t15,
      visible: {
        scale: 1,
        filter: "blur(0px)",
        transition: {
          delay: 0.1
        }
      }
    };
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  let t17;
  if ($[17] !== resumeLastVisitedRoute) {
    t17 = <main className="relative flex items-center h-dvh size-full p-5 select-none flex-col justify-center overflow-hidden sm:p-7">{t2}<div className="flex flex-col items-center justify-center gap-12">{t5}{t8}{t11}<div className="flex w-full flex-wrap items-center justify-center gap-4">{t14}<InView variants={t16} viewOptions={viewOptions} transition={transition} className="sm:w-auto w-full"><Button as="div" onPress={resumeLastVisitedRoute} radius="full" variant="solid" size="lg" color="default" className="sm:w-auto w-full text-lg">Retomar de onde estava</Button></InView></div></div></main>;
    $[17] = resumeLastVisitedRoute;
    $[18] = t17;
  } else {
    t17 = $[18];
  }
  return t17;
}